interface ValidationError {
  code: string;
  detail?: string;
  source?: {
    pointer?: string;
  };
}

export interface ValidationErrors {
  errors?: ValidationError[];
}

export class ResponseError<TData = unknown> extends Error {
  response: Response;
  request: Request;
  data: TData;
  status: number;

  constructor(res: Response, data: TData, request: Request) {
    super(`${request.method} ${request.url} failed with status ${res.status} – ${res.statusText}`);
    this.data = data;
    this.response = res;
    this.status = res.status;
    this.request = request;
    this.name = 'ResponseError';
  }
}

export const isResponseError = (error: unknown): error is ResponseError =>
  error instanceof ResponseError;

export const isValidationError = (error: ResponseError): error is ResponseError<ValidationErrors> =>
  error.data !== null && typeof error.data === 'object' && 'errors' in error.data;
